var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.176 46.77V19.23a5.464 5.464 0 0 0-2.717-4.728L32.718.732a5.412 5.412 0 0 0-5.434 0L3.541 14.501a5.464 5.464 0 0 0-2.717 4.727V46.77a5.464 5.464 0 0 0 2.717 4.728l23.742 13.77a5.412 5.412 0 0 0 5.434 0l23.742-13.77a5.463 5.463 0 0 0 2.717-4.728z",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.46 51.497a5.443 5.443 0 0 0 1.994-2.007L30 32.987V66c.938 0 1.876-.244 2.717-.731l23.742-13.77z",
    fill: "url(#b)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.997 33 28.448-16.5a5.442 5.442 0 0 0-1.989-1.998L32.714.732a5.412 5.412 0 0 0-5.434 0L3.538 14.501a5.442 5.442 0 0 0-1.99 1.998L29.998 33z",
    fill: "url(#c)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.543 51.497a5.443 5.443 0 0 1-1.994-2.007l28.453-16.503V66a5.412 5.412 0 0 1-2.717-.731L3.543 51.498z",
    fill: "url(#d)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 121.844,
    y1: 19.867,
    x2: -148.999,
    y2: -189.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 58.454,
    y1: 32.987,
    x2: 37.521,
    y2: 28.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20E4D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 58.445,
    y1: 0,
    x2: 20.687,
    y2: -14.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20E4D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 30.002,
    y1: 32.987,
    x2: 9.069,
    y2: 28.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20E4D1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.8c637c5af5a8e25475360144ce3c1903.svg";
export { ForwardRef as ReactComponent };